<template>
    <div class="d-flex justify-content-start">
        <small
            ><em class="text-danger">*</em>
            {{ trans('general.required_fields') }}</small
        >
    </div>
</template>
